import React, { useRef, useState } from "react";
import HeadingText from "../../common/HeadingText";
import { assets } from "../../../Assets/assets";
import PropertyCard from "./PropertyCard";
import properties from "../../../config/properties.json"
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";

const PropertyCardSection = () => {
  // const propertyCardData = [
  //   {
  //     id: "property-1",
  //     image: assets.sekhar_mahesh_pride,
  //     name: "sekhar mahesh pride",
  //     location: "Madhusudan Nagar, Unit 4",
  //   },
  //   {
  //     id: "property-2",
  //     image: assets.chandra_sekhar_pride,
  //     name: "chandra sekahr pride",
  //     location: "Saheed Nagar",
  //   },
  //   {
  //     id: "property-3",
  //     image: assets.chandan_sekhar_residency,
  //     name: "chandan sekhar residency",
  //     location: "Jayadev Vihar",
  //   },
  //   {
  //     id: "property-4",
  //     image: assets.sekhar_ratna,
  //     name: "sekahar ratna",
  //     location: "Sastri Nagar",
  //   },
  // ];

  const scrollRef = useRef(null)
  const [propertyCardData, setPropertyCardData] = useState(properties?.properties)


  const scrollLeft = () => {
    scrollRef.current.scrollBy({
      left: -350,
      behavior: "smooth"
    })
  }

  const scrollRight = () => {
    scrollRef.current.scrollBy({
      left: 350,
      behavior: "smooth"
    })
  }

  return (
    <section className="pt-10 xl:px-20 px-6">
      <div className="flex justify-between md:items-center flex-col md:flex-row space-y-3 md:space-y-0">
        <HeadingText
          label={"featured properties"}
          heading={"find your dream home"}
        />
        <div className="space-x-3">
          <button
            onClick={scrollLeft}
            className="bg-gray-600 text-white md:p-3 p-2 rounded-full hover:bg-[#E4E95B] transition-colors duration-300"
          >
            <FaChevronLeft />
          </button>
          <button
            onClick={scrollRight}
            className="bg-gray-600 text-white md:p-3 p-2 rounded-full hover:bg-[#E4E95B] transition-colors duration-300"
          >
            <FaChevronRight />
          </button>
        </div>
      </div>
      <div ref={scrollRef} className="flex overflow-x-scroll snap-mandatory snap-x gap-7 py-3 mt-5">
        {propertyCardData.map((property, index) => (
          <PropertyCard key={index} property={property} />
        ))}
      </div>
    </section>
  );
};

export default PropertyCardSection;
